export const SN_RETURN = 'return'
export const RETURN_LIST_UPDATED = SN_RETURN + '/LIST_UPDATED'
export const RETURN_CURRENT_UPDATED = SN_RETURN + '/CURRENT_UPDATED'
export const RETURN_CURRENT_PRODUCT_ADDED = SN_RETURN + '/CURRENT_PRODUCT_ADDED'
export const RETURN_VALID_STATUS_CHANGE_UPDATED = SN_RETURN + '/VALID_STATUS_CHANGE_UPDATED'